import GetWidgetClassRegistrationQuestionsDefinitionRequestModelBase from '../_generated/modelBases/get-widget-class-registration-questions-definition-request-model-base';

export default class GetWidgetClassRegistrationQuestionsDefinitionRequestModel extends GetWidgetClassRegistrationQuestionsDefinitionRequestModelBase {
  // For instructions on how to use Models visit:
  // https://glittrsoftware.visualstudio.com/glittr.core/_wiki/wikis/glittr.core.wiki/429/ServiceModels-DTOs
}
